import { Dispatch, RefObject } from "react";
import { react } from "uikit";

import MonobankPaymentsCurrency from "./components/MonobankPaymentsCurrency";
import MonobankPaymentsCountryIso from "./components/MonobankPaymentsCountryIso";

interface Context {
	monobankToken: string;
	monobankApiUrl: string;
	currencyRef: RefObject<MonobankPaymentsCurrency.Ref | null>;
	countryIsoRef: RefObject<MonobankPaymentsCountryIso.Ref | null>;
	setMonobankTokenError: Dispatch<boolean>;
	setMonobankApiUrlError: Dispatch<boolean>;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isCurrency = this.context?.currencyRef.current?.validate();
		const isCountryIso = this.context?.countryIsoRef.current?.validate();
		const isToken = !!this.context?.monobankToken.trim();
		const isApiUrl = !!this.context?.monobankApiUrl.trim();

		if (!isToken) {
			this.context?.setMonobankTokenError(true);
		}

		if (!isApiUrl) {
			this.context?.setMonobankApiUrlError(true);
		}

		return [isCurrency, isCountryIso, isToken, isApiUrl].every(Boolean);
	}
}
